import styled from 'styled-components';

const StyledHalfColText = styled.div`
  position: relative;
  width: 100%;
  padding: 0 64px;
  display: flex;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  .title--col{
    flex: 0 0 41.6%;
    width: 41.6%;
  }
  h6{
    position: sticky;
    top: 150px;
    text-align: left;
  }
  @media screen and (max-width: 1439px){
    padding: 0 40px;
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    padding: 0 24px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    flex-direction: column;
    .title--col{
      flex: 0 0 100%;
      width: 100%;
    }
    h6{
      padding-bottom: 16px;
    }
  }
  
`;

export {
  StyledHalfColText,
};

